<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex xs12 mt-3>
          <v-flex d-flex align-center justify-space-between>
            <h1 class="headline">
              {{ $t('driverRating.title') }} - {{ driverName }}
            </h1>
          </v-flex>
        </v-flex>
      </v-layout>

      <v-data-table
        class="mt-5"
        :headers="headers"
        :items="items"
        :expanded.sync="expandedItems"
        :items-per-page="-1"
        :loading="loading"
        item-key="name"
        single-expand
        hide-default-footer
      >
        <template #item="{ item, expand, isExpanded }">
          <tr>
            <td width="50">
              <v-btn
                v-if="item.list && item.list.length"
                class="expand-btn"
                :class="{ isExpanded }"
                icon
                small
                @click="expand(!isExpanded)"
              >
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </td>
            <td>{{ item.name }}</td>
            <td>
              <b :class="getScoreClass(item.score)">
                {{ item.score }}
              </b>
            </td>
          </tr>
        </template>

        <template v-if="items.length" #[`body.append`]>
          <tr class="grey lighten-3">
            <td />
            <td>
              <b>{{ $t('driverRating.title') }}</b>
            </td>
            <td>
              <b>{{ driverRating.scoreTotal }}</b>
            </td>
          </tr>
        </template>

        <template #expanded-item="{ item }">
          <tr>
            <td colspan="4">
              <v-simple-table class="expanded-content-table">
                <tbody>
                  <tr v-for="(el, key) in item.list" :key="key">
                    <td align="center">{{ el.accident_date }}</td>
                    <td align="center" :class="getScoreClass(el.accidentScore)">
                      {{ el.accidentScore }}
                    </td>
                    <td
                      align="center"
                      :class="el.isGuilty ? 'red--text' : 'green--text'"
                    >
                      {{ el.isGuilty ? $t('dtp.guilty') : $t('dtp.noGuilty') }}
                    </td>
                    <td></td>
                  </tr>
                </tbody>
              </v-simple-table>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  data: () => ({
    loading: false,
    expandedItems: [],
  }),
  computed: {
    driverName() {
      return this.$store.getters['driver/getDriverName'];
    },
    driverRating() {
      return this.$store.state.driver.driverRating;
    },
    headers() {
      return [
        { sortable: false },
        {
          text: this.$t('driverRating.category'),
          value: 'name',
          sortable: false,
        },
        {
          text: this.$t('driverRating.score'),
          value: 'score',
          sortable: false,
        },
      ];
    },
    items() {
      if (this.loading) return [];

      return [
        {
          name: this.$t('driverRating.configurtor.insurance'),
          score: this.driverRating.insuranceScore,
        },
        {
          name: this.$t('driverRating.configurtor.age'),
          score: this.driverRating.ageScore,
        },
        {
          name: this.$t('driverRating.configurtor.experience'),
          score: this.driverRating.drivingExperienceScore,
        },
        {
          name: this.$t('driverRating.configurtor.stability'),
          score: this.driverRating.stableScore,
        },
        {
          name: this.$t('driverRating.configurtor.adequacy'),
          score: this.driverRating.adequacyScore,
        },
        {
          name: this.$t('driverRating.configurtor.stable'),
          score: this.driverRating.stableDriverScore,
        },
        {
          name: this.$t('driverRating.configurtor.dtp'),
          score: this.driverRating.carAccidentsScore,
          list: this.driverRating.carAccidents,
        },
      ];
    },
  },
  methods: {
    async fetchList() {
      this.loading = true;
      await this.$store.dispatch('driver/fetchDriverRating', {
        driverId: this.$route.params.driverId,
      });
      this.loading = false;
    },
    getScoreClass(num) {
      if (num === 0) return 'blue-grey--text';
      return num >= 0 ? 'green--text' : 'red--text';
    },
  },
  created() {
    this.fetchList();
  },
};
</script>

<style lang="scss">
.expand-btn {
  transition: 300ms;

  &.isExpanded {
    transform: rotate(-180deg);
  }
}

.expanded-content-table {
  max-width: 400px;
  margin: 5px auto;

  tr:hover {
    background-color: transparent !important;
  }
}
</style>
